import type { TeamMember } from "../../../../features/Booking-Form/typings/team-member";

export function teamMemberDisplayLine(member: TeamMember): string {
  const name = `${member.firstName ?? ""} ${member.surname ?? ""}`.trim();
  const email = member.email ?? "";
  return email ? `${name} (${email})` : name;
}

/**
 * Team confirm: internal members in one list; visitors (invitation / external rows) under a separate heading.
 */
export function buildTeamBookingConfirmSummary(
  usersBookedFor: TeamMember[] | undefined,
  translate: (key: string) => string
): string {
  if (!usersBookedFor?.length) {
    return translate("Not set");
  }
  const visitors = usersBookedFor.filter(m => m.isExternal === true);
  const internals = usersBookedFor.filter(m => m.isExternal !== true);

  const blocks: string[] = [];
  if (internals.length > 0) {
    blocks.push(internals.map(teamMemberDisplayLine).join(", \n"));
  }
  if (visitors.length > 0) {
    blocks.push(
      `${translate("_formConfirmTeam_sectionVisitors")}\n${visitors.map(teamMemberDisplayLine).join(", \n")}`
    );
  }
  return blocks.join("\n\n");
}
